import * as api from './medical-notes-api';
import * as actions from './medical-notes-action-creator';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';

const sortMedicalNotes = (notes) =>
  notes.sort((a, b) => new Date(b.serviceDate) - new Date(a.serviceDate));

export const loadMedicalNotes = (patientId) => (dispatch, getState) =>
  api.getMedicalNotes(patientId)
    .then(
      (response) => {
        const userPreferenceDateFilter = getState().profile.user.preferences.PatientPortal_MedicalNotesFilter_Date;
        dispatch(actions.medicalNotesLoadedSuccess(sortMedicalNotes(response.data), userPreferenceDateFilter));
      },
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );

export const loadNewMedicalNotesCount = (patientId) => (dispatch) =>
  api.getNewMedicalNotesCount(patientId)
    .then(
      (response) => dispatch(actions.newMedicalNotesCountLoadedSuccess(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );

export const setMedicalNoteAsReviewed = (patientId, medicalNoteId) => (dispatch) =>
  api.updateMedicalNoteAsReviewed(patientId, medicalNoteId)
    .then(
      () => dispatch(actions.setMedicalNoteReviewedSuccess(medicalNoteId)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );

export const setTotalNumberOfPages = (numberOfPages) => (dispatch) =>
  dispatch(actions.setTotalNumberOfPages(numberOfPages));

export const setCurrentPageNumber = (pageNumber) => (dispatch) =>
  dispatch(actions.setCurrentPageNumber(pageNumber));

export const setMedicalNotePageUrl = (patientId, medicalNoteId, pageNumber, token) => (dispatch) =>
  dispatch(actions.setCurrentPageUrl(api.medicalNotePageUrl(patientId, medicalNoteId, pageNumber, token)));